import { FirearmStorageLocationPLIResolverBase } from './firearm-storage-location-pli.resolver.base';
import { FirearmStorageLocationPLIService } from './firearm-storage-location-pli.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmStorageLocationPLIResolver extends FirearmStorageLocationPLIResolverBase {

  constructor(protected service: FirearmStorageLocationPLIService) {
    super(service);
  }
}



